module.exports = __webpack_public_path__ + "static/media/dinner3.d8adbc83.png";